<template>
  <IntercomInput
    :model-value="emailValue"
    type="email"
    inputmode="email"
    autocomplete="email"
    :valid="isValid"
    :error="error"
    :label="label"
    :placeholder="placeholder"
    :required="required"
    :disabled="disabled"
    v-bind="$attrs"
    @update:model-value="handleInput"
    @blur="handleBlur"
  />
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import IntercomInput from './IntercomInput.vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'blur', 'update:valid'])

const emailValue = ref(props.modelValue || '')

// Standard email regex pattern
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== emailValue.value) {
      emailValue.value = newValue || ''
    }
  }
)

const isValid = computed(() => {
  if (!emailValue.value) return false
  return emailRegex.test(emailValue.value)
})

watch(isValid, (valid) => {
  emit('update:valid', valid)
}, { immediate: true })

const handleInput = (value) => {
  emailValue.value = value
  emit('update:modelValue', value)
}

const handleBlur = (event) => {
  emit('blur', event)
}
</script>
